import {Component, ElementRef, OnInit} from '@angular/core';
import {Router} from "@angular/router";
import {ROUTES} from '../sidebar/sidebar.component';
import {Location} from '@angular/common';

import {AuthenticationService} from "app/services/authentication.service";
import {UserSelf} from "app/models/userSelf";
import {Client} from 'app/models/client';
import {Notification} from "app/models/notification";
import {NotificationService} from '../../../../services/notification.service';
import * as signalR from "@aspnet/signalr";
import {IndividualConfig, ToastrService} from 'ngx-toastr';

const authenticatedUserKey = "authenticatedUser";


@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {
    private listTitles: any[];
    location: Location;
    private toggleButton: any;
    private sidebarVisible: boolean;
    private client: Client;
    private notifications: Notification[] = [];
    private notificationCountPerLoad: number = 10;
    private currentLoad: number = 1;
    private natificationsTotalCount: number;
    private newNotificationsCount: number = 0;
    private hubConnection: signalR.HubConnection;
    private toastrOptions: Partial<IndividualConfig> = {
      timeOut: 40000,
      positionClass: 'toast-bottom-right',
      progressBar: true,
      progressAnimation: 'decreasing',
      closeButton: true,
      tapToDismiss: true
    };

    constructor(
      location: Location,
      private element: ElementRef,
      private _authenticationService: AuthenticationService,
      private _notificationService: NotificationService,
      private toastr: ToastrService,
      private _router: Router) {
      this.location = location;
          this.sidebarVisible = false;
    }

    ngOnInit(){
      this.listTitles = ROUTES.filter(listTitle => listTitle);
      const navbar: HTMLElement = this.element.nativeElement;
      this.toggleButton = navbar.getElementsByClassName('navbar-toggle')[0];
      let authenticatedUserJson = localStorage.getItem(authenticatedUserKey);
      let user = authenticatedUserJson ? Object.assign(Object.create(UserSelf.prototype), JSON.parse(authenticatedUserJson)): null
      this.client = (user) ? user.client : null;

      this._notificationService.getNewNotificationsCount()
        .subscribe(count => { this.newNotificationsCount = count; });

      this.startConnection();
    }

    private loadNotifications() {
      this.currentLoad = 1;
      this.notifications = []
      this.getNotifications(this.currentLoad);
    }

    private loadMoreNotifications() {
      event.stopPropagation();
      this.currentLoad++;
      this.getNotifications(this.currentLoad);
    }

    public startConnection = () => {
      this.hubConnection = new signalR.HubConnectionBuilder()
        .withUrl(`/api/userHub?user_id=${this._authenticationService.authenticatedUser.id}`)
        .build();

      this.hubConnection.on("newMessage", (notificationId: number, callId: number, callNumber: string) => {
        this.toastr.success('По обращению ' + callNumber + ' добавлен комментарий', null, this.toastrOptions)
          .onTap
          .subscribe(() => this.confirmNotification(notificationId, '/call/' + callId + '/message/'));
      });

      this.hubConnection.on("notLookedNotificationCountChanged", (notLookedNotificationCount: number) => {
        this.newNotificationsCount = notLookedNotificationCount;
      });

      this.hubConnection.on('clientSettingsChanged', () => {
        this._authenticationService.replaceClientSettings()
      });

      this.hubConnection
        .start()
        .then(() => console.log('Connection started'))
        .catch((err) => console.log(`Error while starting connection: ${err}`));
    }

    private confirmNotification(notificationId: number, notificationLink: string) {
      this._notificationService.confirmNotification(notificationId)
        .subscribe(_ => {
          this._router.navigate([notificationLink]);
        });
    }

    private confirmAllNotifications() {
      this._notificationService.confirmAllNotifications()
        .subscribe(_ => { });
    }

    private getNotifications(currentLoad) {
      this._notificationService.getNotifications(this.notificationCountPerLoad, (currentLoad - 1) * this.notificationCountPerLoad)
        .subscribe(notifications => {
          this.notifications = this.notifications.concat(notifications.items);
          this.natificationsTotalCount = notifications.totalCount;
        });
    }

    sidebarOpen() {
        const toggleButton = this.toggleButton;
        const body = document.getElementsByTagName('body')[0];
        setTimeout(function(){
            toggleButton.classList.add('toggled');
        }, 500);
        body.classList.add('nav-open');

        this.sidebarVisible = true;
    };
    sidebarClose() {
        const body = document.getElementsByTagName('body')[0];
        this.toggleButton.classList.remove('toggled');
        this.sidebarVisible = false;
        body.classList.remove('nav-open');
    };
    sidebarToggle() {
        // const toggleButton = this.toggleButton;
        // const body = document.getElementsByTagName('body')[0];
        if (this.sidebarVisible === false) {
            this.sidebarOpen();
        } else {
            this.sidebarClose();
        }
    };

    getTitle(){
      const titlee = this.location.prepareExternalUrl(this.location.path());

      for(let item = 0; item < this.listTitles.length; item++){
          if(this.listTitles[item].path === titlee){
              return this.listTitles[item].title;
          }
      }
      return '';
    }

    get authenticatedUser(): UserSelf {
      return this._authenticationService.authenticatedUser;
    }

    signOut() {
      this._authenticationService.signOut();
      this._router.navigate(['/account/signin']);
    };
}



// WEBPACK FOOTER //
// /app/SPA/src/app/client/components/main/navbar/navbar.component.ts